import React from "react";
import styled from "@emotion/styled";
import { Flex, Box, Text } from "@graphite/uneon";

import circleImage from "../../images/circle.svg";

const Wrapper = styled(Box)`
	position: relative;
	flex-direction: column;
	align-items: center;
`;

const Header = styled(Text)`
	-webkit-background-clip: text !important;
	-webkit-text-fill-color: transparent;
	background: linear-gradient(
		287.43deg,
		rgb(119, 77, 255) 33.27%,
		rgb(35, 158, 185) 61.72%,
		rgb(215, 62, 135) 82.93%
	);
	text-transform: uppercase;
`;

const List = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;

	li {
		background: url(${circleImage});
		background-repeat: no-repeat;
		background-position-y: 50%;
		padding-left: 20px;

		&:not(:last-child) {
			margin-bottom: 9px;
		}
	}
`;

const columnSx = {
	gridColumn: ["span 12 !important", "span 4 !important"],
};

const YouWillLoveIt = () => (
	<>
		<Flex variant="gridcontainer" justifyContent={["left", "center"]}>
			<Header
				variant="sectionmd"
				color="text.accent"
				mt={["60px", "90px"]}
				textTransform="uppercase"
			>
				You’ll love it
			</Header>
		</Flex>
		<Wrapper
			variant="gridcontainer"
			maxWidth="1000px !important"
			alignItems="start !important"
		>
			<Box sx={columnSx} mt="40px">
				<Text variant="title5" color="text.primaryalt" mb="24px">
					Comfort
				</Text>
				<List>
					<li>
						<Text variant="bodymd" color="text.primary">
							Familiar look and feel
						</Text>
					</li>
					<li>
						<Text variant="bodymd" color="text.primary">
							Design system
						</Text>
					</li>
					<li>
						<Text variant="bodymd" color="text.primary">
							Absolute & Auto-Layout
						</Text>
					</li>
				</List>
			</Box>

			<Box sx={columnSx} mt="40px">
				<Text variant="title5" color="text.primaryalt" mb="24px">
					Power
				</Text>
				<List>
					<li>
						<Text variant="bodymd" color="text.primary">
							Top-notch animation
						</Text>
					</li>
					<li>
						<Text variant="bodymd" color="text.primary">
							Pixel-perfect rendering
						</Text>
					</li>
					<li>
						<Text variant="bodymd" color="text.primary">
							CSS/Flexbox firepower
						</Text>
					</li>
				</List>
			</Box>
			<Box sx={columnSx} mt="40px">
				<Text variant="title5" color="text.primaryalt" mb="24px">
					Efficiency
				</Text>
				<List>
					<li>
						<Text variant="bodymd" color="text.primary">
							Bulk adjustments
						</Text>
					</li>
					<li>
						<Text variant="bodymd" color="text.primary">
							Reusable components
						</Text>
					</li>
					<li>
						<Text variant="bodymd" color="text.primary">
							Instant publishing
						</Text>
					</li>
				</List>
			</Box>
		</Wrapper>
	</>
);

export default React.memo(YouWillLoveIt);
